import { render, staticRenderFns } from "./FluxView.vue?vue&type=template&id=03cfc336&scoped=true&"
import script from "./FluxView.vue?vue&type=script&lang=js&"
export * from "./FluxView.vue?vue&type=script&lang=js&"
import style0 from "./FluxView.vue?vue&type=style&index=0&id=03cfc336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cfc336",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
